import * as React from 'react';
import { injectIntl } from 'react-intl';
import { compose } from 'redux';
import { Loader } from 'semantic-ui-react';

import analytics from '../../shared/services/analytics/analytics';
import { AlphaDetailsSummaryColumns } from '../../shared/data/AlphaDetailsSummaryColumns';
import HOCStageChooser from '../HOCStageChooser/HOCStageChooser';

import { TestingStatusGeneric } from './types';
import TestingStatusMain from './TestingStatus/TestingStatusMain';

export class AlphaTestingStatusIntl extends React.Component<TestingStatusGeneric> {
  state = {
    typeCheck: { passed: false, failed: false, pending: false, aggregateData: false },
  };

  UNSAFE_componentWillReceiveProps(nextProps: TestingStatusGeneric) {
    if (nextProps.alphaId !== this.props.alphaId) {
      this.setState({ typeCheck: { passed: false, failed: false, pending: false, aggregateData: false } });
    }
  }

  handleClick = (id: string) => {
    const typeCheck: any = { ...this.state.typeCheck };
    if (!typeCheck[id]) {
      analytics.trackCustomEvent('sim_expand_testing_status', { event_label: id });
    }
    typeCheck[id] = !typeCheck[id];
    this.setState({ typeCheck });
  };

  render() {
    const { alpha, fetchingCheck, fetchingSubmissionAlpha, tabsStageAlphas } = this.props;

    const typeStage = this.props.typeStage === 'test' || this.props.typeStage === 'train' ? 'is' : this.props.typeStage;
    const tableHeader = AlphaDetailsSummaryColumns[typeStage];

    const alphaChecks = alpha && alpha.getIn([typeStage, 'checks']);
    const checks = alphaChecks !== undefined ? alphaChecks.toJS() : null;
    if (fetchingCheck || fetchingSubmissionAlpha) {
      return (
        <div className="loader">
          <Loader active={true} inline="centered" size="massive" />
        </div>
      );
    } else {
      return (
        <React.Fragment>
          {alpha && (
            <TestingStatusMain
              tableHeader={tableHeader}
              checks={checks}
              typeStage={typeStage}
              tabsStageAlphas={tabsStageAlphas}
              handleClick={this.handleClick}
              typeCheck={this.state.typeCheck}
            />
          )}
        </React.Fragment>
      );
    }
  }
}

export default compose<any>(injectIntl, HOCStageChooser)(AlphaTestingStatusIntl);
